import useAPICom from '../hooks/useAPICom.js';

const Home = () => {
    const res = useAPICom("full","https://jsonplaceholder.typicode.com/todos");
    if (!res.response) {
        return <div>Loading...</div>
    }
    return (
        <div>
            <h1 className="wow">Test Home Page</h1>

        <h2 id="head1">Sub Heading 1</h2>

        <p>
          Lorem, <a href="https://www.lipsum.com/">ipsum</a>
          dolor sit amet consectetur adipisicing elit.
        </p>

        <ul>
          <li>List item 1</li>
                <li className="wow">List item 2</li>
          <li>List item 3</li>
        </ul>


        <h2 id="head2">Sub Heading 2</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum debitis
                molestias <span className="wow">omnis</span> voluptas, consequatur ex cumque
          velit libero quidem est?
            </p>
        </div>
    )
};

export default Home;
